const ImagePreview = (props) => {
    return (
        <div onClick={()=>props.delete(props.id)} width='440px' >
            <img alt='プレビュー画像' src={props.path} width='100%' />
        </div>
    )
}

export default ImagePreview